import { ShieldAlert, ArrowUpCircle } from "lucide-react";
import { useTranslation } from "@/packages/utils";
import { ConfirmDialog } from "@/components/ui/ConfirmDialog";
import { Button, Badge } from "@/components/ui/primitives";
import { useAuditLimitModal } from "./audit-limit-modal-store";

export function AuditLimitModal() {
  const { t } = useTranslation("common");
  const { isOpen, maxAudits, close } = useAuditLimitModal();

  return (
    <ConfirmDialog open={isOpen} onClose={close}>
      <ConfirmDialog.Title>
        {t("billing.auditLimitReached")}
      </ConfirmDialog.Title>
      <ConfirmDialog.Body>
        <div className="space-y-4">
          <div className="flex items-start gap-3">
            <div className="rounded-full bg-orange-500/10 p-2.5 shrink-0">
              <ShieldAlert size={20} className="text-orange-500" />
            </div>
            <p className="text-[14px] text-secondary leading-relaxed">
              {t("billing.auditLimitDescription", { count: maxAudits ?? 0 })}
            </p>
          </div>

          <div className="flex items-center gap-2">
            <Button variant="primary" disabled className="opacity-50">
              <ArrowUpCircle size={14} />
              {t("billing.upgradePlan")}
            </Button>
            <Badge
              color={{
                bg: "rgba(59,130,246,0.15)",
                text: "#3b82f6",
              }}
            >
              {t("ai.credits.comingSoon")}
            </Badge>
          </div>
        </div>
      </ConfirmDialog.Body>
      <div className="flex items-center justify-end px-6 py-4 border-t border-border">
        <Button
          variant="ghost"
          onClick={close}
          className="bg-card-hover hover:bg-card-hover/80 text-primary"
        >
          {t("actions.close")}
        </Button>
      </div>
    </ConfirmDialog>
  );
}
